import { regionHelper } from "../../region";

export function menuDataUrl(relativeUrl: string) {
    const isAbsolute = relativeUrl.indexOf("://") !== -1;

    return isAbsolute
        ? relativeUrl
        : regionHelper.region.locationDataUrl + "/" + relativeUrl.replace(/^\/menu\/data/, "").replace(/^\//, "");
}
